const $ = jQuery.noConflict();

class Accordions {
	constructor(trigger) {
		this.trigger = $(trigger);
	}
	init() {
		this.bindEvents();
	}
	bindEvents() {
		this.trigger.on('click', this.toggleAccordion);
	}
	toggleAccordion() {
		//$('.bellow').removeClass('active');
		//if ($(this).parent().hasClass('highlight')) {
		// if ($('#section1.bellow').hasClass('highlight')) {
		// 	$('#section1.bellow').removeClass('highlight');
		// 	$('#section3.bellow').removeClass('highlight');
		// 	$(this).parent().toggleClass('highlight');
		// }
		// if ($(".bellow").hasClass("highlight")) {
		// }
		$(this).parent().prev().removeClass('active');
		$(this).parent().next().removeClass('active');
		//$(this).parent().toggleClass('highlight');
		$(this).parent().toggleClass('active');
		$(this).next().stop().slideToggle(250);
	}
}

export default new Accordions('.bellow__title');
